import { FormCard } from '@/components/common/FormCard';
import { PageSection } from '@/components/common/PageSection';
import { GuaranteeCard } from '@/pages/GetStarted/components/GuaranteeCard';
import { NextStepsCard } from '@/pages/GetStarted/components/NextStepsCard';
import { ProjectRequestForm } from '@/pages/GetStarted/components/ProjectRequestForm';

const TitleId = 'project-request-title';

export function ProjectRequestSection() {
  return (
    <PageSection titleId={TitleId} tone="pad">
      <div className="grid gap-8 lg:grid-cols-12 lg:items-start lg:gap-12">
        <FormCard className="lg:col-span-8">
          <ProjectRequestForm titleId={TitleId} />
        </FormCard>
        <aside className="space-y-6 lg:col-span-4">
          <NextStepsCard />
          <GuaranteeCard />
        </aside>
      </div>
    </PageSection>
  );
}